import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { OmegleAlternativeBanner } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function OmegleAlternative() {
  return (
    <>
      <SEO
        title="Best Omegle Alternative - Talkvee (Safe & Ad-Free)"
        description="Looking for the best Omegle alternative? Talkvee is the top-rated site to talk to strangers. Safer moderation, no ads, and fun built-in games."
        pathname="/omegle-alternative"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Omegle Alternative", "item": "https://talkvee.com/omegle-alternative" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <OmegleAlternativeBanner />
        
        <section className="landing-hero">
          <h1 className="landing-title">The #1 Omegle Alternative</h1>
          <p className="landing-subtitle">
            Omegle might be gone, but the spirit of meeting new people lives on. 
            Talkvee is a safer, faster, and more fun way to video chat with strangers 
            instantly—right in your browser.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Why Talkvee is the best choice</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#fee2e2', padding: '20px', borderRadius: '12px', border: '1px solid #fecaca'}}>
              <h4 style={{margin: '0 0 10px', color: '#b91c1c', fontSize: '1.1rem'}}>❌ Old Sites</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#7f1d1d', lineHeight: '1.6'}}>
                <li>Toxic Environments</li>
                <li>Annoying Pop-up Ads</li>
                <li>Full of Bots</li>
              </ul>
            </div>
            <div style={{background: '#dcfce7', padding: '20px', borderRadius: '12px', border: '1px solid #bbf7d0'}}>
              <h4 style={{margin: '0 0 10px', color: '#15803d', fontSize: '1.1rem'}}>✅ Talkvee</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#14532d', lineHeight: '1.6'}}>
                <li>AI-Powered Moderation</li>
                <li>100% Ad-Free Experience</li>
                <li>Built-in Icebreaker Games</li>
              </ul>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "Is Talkvee the same as Omegle?",
              a: "It's the same concept—connecting with strangers via video—but with modern improvements. We focus on safety, speed, and adding fun through games."
            },
            {
              q: "Is there an Omegle app for iPhone or Android?",
              a: "Omegle never had an official app, and neither does Talkvee. We are a PWA (Progressive Web App), meaning you can install us directly from your browser for a full-screen experience."
            },
            {
              q: "How does Talkvee keep the community safe?",
              a: "We use automated moderation and a reporting system to ban users who violate our community guidelines, ensuring a respectful environment for everyone."
            }
          ]}
        />
      </div>
    </>
  );
}